import { useState, useCallback, useEffect, useRef } from 'react';
import { useRafState, useUnmount } from 'react-use';
import { DRAWER_TRANSITION_DURATION } from 'src/components/Drawers/consts';
import useNavigationStore from 'src/stores/useNavigationStore';
import { SetTimeoutResult } from 'src/utils/UtilityTypes';

export default function useMobileNav() {
	const isOpen = useNavigationStore((s) => s.showMobileNavMenu);
	const setNavigationStore = useNavigationStore((s) => s.set);

	const [isClosing, setIsClosing] = useState(false);
	const closeTimeoutRef = useRef<SetTimeoutResult>(null);

	const close = useCallback(() => {
		if (isClosing) {
			return;
		}

		setIsClosing(true);

		closeTimeoutRef.current = setTimeout(() => {
			setNavigationStore((s) => {
				s.showMobileNavMenu = false;
			});

			setIsClosing(false);
			closeTimeoutRef.current = null;
		}, DRAWER_TRANSITION_DURATION);
	}, [setNavigationStore, isClosing]);

	useUnmount(() => {
		if (closeTimeoutRef.current) {
			clearTimeout(closeTimeoutRef.current);
		}
	});

	// State set on the next frame used for transitions so they don't get clobbered.
	const [isOpenRaf, setIsOpenRaf] = useRafState(false);
	useEffect(() => {
		setIsOpenRaf(isOpen && !isClosing);
	}, [isOpen, isClosing]);

	return {
		close,
		isOpen,
		isOpenRaf,
	};
}
